module.exports = __webpack_public_path__ + "img/w3_link_light.4002c335.png";